import { render, staticRenderFns } from "./StoreCustomerDetail.vue?vue&type=template&id=442f5ffe&scoped=true&"
import script from "./StoreCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./StoreCustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f5ffe",
  null
  
)

export default component.exports